import React, { useReducer } from 'react'

import { LanguageContext, defaultState } from './Language.context'
import { LanguageReducer } from './Language.reducer'
import {
  UPDATE_LANGUAGE,
  LanguageState,
  LanguageOptions,
} from './Language.types'

interface Props {
  children?: React.ReactNode
}

export const LanguageProvider: React.FC<Props> = ({ children }) => {
  let initialState: LanguageState = defaultState

  const [state, dispatch] = useReducer(LanguageReducer, initialState)

  const updateLanguage = (language: LanguageOptions) => {
    dispatch({ type: UPDATE_LANGUAGE, payload: language })
  }
  initialState = {
    ...initialState,
    updateLanguage,
  }
  return (
    <LanguageContext.Provider
      value={{
        language: state.language,
        updateLanguage,
      }}
    >
      {children}
    </LanguageContext.Provider>
  )
}
